import script from "./JobDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./JobDetail.vue?vue&type=script&lang=ts&setup=true"

import "./JobDetail.vue?vue&type=style&index=0&id=4250941c&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4250941c"]])

export default __exports__